export default function imageParallax() {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray(".trazan-parallax").forEach((container) => {
        let image = container.querySelector("img");

        if (image._parallaxST) {
            image._parallaxST.kill();
        }

        let st = gsap.fromTo(image,
            {
                y: () => -image.offsetHeight * 0.2
            },
            {
                y: () =>  image.offsetHeight * 0.2,
                ease: "none",
                scrollTrigger: {
                    trigger: container,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    invalidateOnRefresh: true,
                    markers: false,
                    pin: false
                }
            }
        ).scrollTrigger;

        image._parallaxST = st;
    });
}
